import { Box, Button, Card, CardContent, CardHeader, Container, Hidden, makeStyles, MuiThemeProvider, Paper, Typography, useMediaQuery } from '@material-ui/core';
import clsx from 'clsx';
import { bookingState } from 'pages/CustomerBooking/RecoilState';
import Qrcode from "qrcode.react";
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import themes from 'themes';
import { HelvNeue } from 'themes/theme';
import { BookingType } from '../BookingDetail/BookingType';
import { useBranch } from '@zennya/web-component-library/src/components/BranchIO/BranchProvider'
import { useTrackEvent } from 'util/trackEvent';
import { getDeepLinkLogin } from 'services/booking.service';

const BP_MOBILE = 960
const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: '#fff',
      height: '100%',
      width: '100%',
    },
    roundBack: {
      width: `calc(100% - ${theme.spacing(5) * 2}px)`,
      height: `calc(100% - ${theme.spacing(5) * 2}px)`,
      margin: theme.spacing(5),
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: theme.palette.secondary.main,
      [theme.breakpoints.down(BP_MOBILE)]: {
        margin: 0,
        paddingTop: theme.spacing(5),
        height: '100%',
        width: '100%',
        backgroundColor: 'white',
        flexDirection: 'column',
      },
    },
    leftBox: {
      flex: '1 1 50%',
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: "column",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: theme.palette.secondary.main,
      [theme.breakpoints.down(BP_MOBILE)]: {
        backgroundColor: 'white',
      },
    },
    rightBox: {
      flex: '1 1 50%',
      borderRadius: theme.shape.borderRadius,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.secondary.whisper,
      [theme.breakpoints.down(BP_MOBILE)]: {
        backgroundColor: 'white',
        flexDirection: 'column-reverse',
      },
    },
    bookingBox: {
      flex: '1 1 50%',
      margin: theme.spacing(2),
    },
    handBox: {
      position: 'relative',
      flex: '1 1 50%',
      filter: "contrast(100%) brightness(100%)",
      background: "linear-gradient(60deg, rgba(187,228,228,1), rgba(127, 138, 172, .5)), url(/assets/images/cloudp.svg)",
      '&>img': {
        maxHeight: '115%',
        maxWidth: '100%',
        position: 'absolute',
        bottom: 0,
        [theme.breakpoints.down(BP_MOBILE)]: {
          left: '50%',
        },
        left: '45%',
        transform: "translateX(calc(-50% - 45px))",
      },
      [theme.breakpoints.down(BP_MOBILE)]: {
        minHeight: '200px',
        marginTop: 60
      },

    },
    helvetica: {
      fontFamily: HelvNeue
    },
    qrBox: {
      marginTop: theme.spacing(2),
      textAlign: 'center',
    },
    cardHeader: {
      textAlign: 'center'
    },
    insideBanner: {
      background: "linear-gradient(268.89deg, #7F8AAC 12.95%, #74BACD 97.46%)",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      width: '100%',
      marginBottom: theme.spacing(2),
      color: theme.palette.background.paper,
      fontWeight: 'bold',
    }
  }
})
const PostBooking = ({ }) => {
  const classes = useStyles()
  const history = useHistory()
  const booking = useRecoilValue(bookingState)

  const trackEvent = useTrackEvent()

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down(BP_MOBILE), {
    noSsr: true,
  });

  const [deepLinkLogin, setDeepLinkLogin] = useState(null);

  const fetchDeeplink = useCallback(
    async (id) => {
      const res = await getDeepLinkLogin(id)
      setDeepLinkLogin(res?.app_deep_link)
    },
    [],
  );

  useEffect(() => {
    fetchDeeplink(booking?.id)
  }, [booking?.id]);

  const onSummaryClick = useCallback(
    () => {
      history.replace(`/bookings/${booking?.id}` + history.location.search)
    },
    [booking?.id, history],
  );

  return (
    <div className={classes.root}>
      <Box className={classes.roundBack}>
        <MuiThemeProvider theme={isMobile ? themes.default : themes.dark}>
          <Paper elevation={0} className={classes.leftBox}>
            {isMobile && (
              <Typography align="center" variant="body2" className={classes.insideBanner}>
                Open the zennya app and  log in to access your records
              </Typography>
            )}
            <Container fixed>
              <Typography align="center" variant="h2" gutterBottom className={clsx(classes.helvetica, classes.title)}>Securely access your results on the app</Typography>
              <Typography align="center" variant="body1" gutterBottom color=''>Always have access to your medical history and result analytics on the zennya health app</Typography>
              {isMobile && (
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={()=>{
                    trackEvent('Post booking - Open App - click', {})
                    window.location.href = deepLinkLogin
                  }}
                >
                  View results on the app
                </Button>
              )}
            </Container>
            {!isMobile &&
              (
                <MuiThemeProvider theme={themes.default}>
                  <Card variant="outlined" className={classes.qrBox}>
                    <CardHeader
                      classes={{
                        root: classes.cardHeader
                      }}
                      title="Scan or click to open the app" />
                    <CardContent>
                      <Qrcode 
                      onClick={()=>{
                        trackEvent('Post booking - QR - click', {})
                        window.location.href = deepLinkLogin
                      }}
                      value={deepLinkLogin ?? ""} renderAs="svg" size={256} />
                    </CardContent>

                  </Card>
                </MuiThemeProvider>
              )
            }
          </Paper>
        </MuiThemeProvider>
        <Box className={classes.rightBox}>
          <Box className={classes.bookingBox}>
            <BookingType booking={booking} />
            <Button fullWidth variant="outlined" color="primary" size="large" onClick={() => {
              onSummaryClick()
              trackEvent('Post booking - View summary - click', {})
            }}>See booking summary</Button>
          </Box>
          <Box className={classes.handBox}>
            <img src='/assets/images/hand.png' />
          </Box>
        </Box>
      </Box>
    </div>
  )
}

export { PostBooking };
